<section class="pit-card income">
  <div class="pit-card__head">
    <div>
      <h3 class="pit-title">Renda que sobra após o crescimento patrimonial</h3>
      <p class="pit-caption">
        Ano-calendário {{ test().calendarYear }} · mostra se a renda declarada explica o quanto o
        patrimônio cresceu
      </p>
    </div>
    <div class="income__verdict">
      <span
        class="pit-tag"
        [class.pit-tag--success]="compatible()"
        [class.pit-tag--danger]="!compatible()">
        {{ compatible() ? 'Compatível' : 'A descoberto' }}
      </span>
      <b class="pit-num" [class.pit-positive]="compatible()" [class.pit-negative]="!compatible()">
        {{ money(result(), true) }}
      </b>
    </div>
  </div>

  <details class="income__explain">
    <summary>
      <i class="pi pi-chevron-right income__chevron" aria-hidden="true"></i>
      O que é e como é calculado
    </summary>
    <div class="income__explain-body">
      <p>
        É o teste de acréscimo patrimonial a descoberto que a Receita Federal aplica. Compara os
        recursos que o sócio teve no ano com o crescimento do patrimônio líquido dele.
      </p>
      <p>
        <b>Recursos disponíveis</b> = tributáveis líquidos de IR + isentos e não tributáveis +
        tributação exclusiva (líquidos) − pagamentos declarados − custo de vida estimado.
      </p>
      <p>
        <b>Renda que sobra</b> = recursos disponíveis − acréscimo patrimonial (PL no fim do ano − PL
        no fim do ano anterior).
      </p>
      <p>
        Positiva: a renda declarada explica o crescimento. Negativa: o patrimônio cresceu mais do
        que a renda justifica; peça comprovação (renda omitida, doação ou herança, bem subavaliado
        no ano anterior, erro de preenchimento).
      </p>
      <p>
        O custo de vida estimado é premissa do analista. Os demais valores vêm da declaração e podem
        ser ajustados. Quando chegar a declaração do próximo ano, o teste passa a usar o novo ano e
        o anterior fica no histórico.
      </p>
    </div>
  </details>

  @if (livingCostMissing()) {
    <div class="pit-callout pit-callout--warning">
      <span>
        <b>Premissa não informada:</b> o custo de vida estimado está vazio e o teste considera zero.
        Informe a premissa para o resultado refletir o gasto do sócio.
      </span>
    </div>
  }

  <div class="income__fields">
    @for (field of fields; track field.key) {
      <div class="income__field" (focusout)="onBlur(field.key)">
        <span class="income__field-head">
          <label [for]="'pit-income-' + field.key">{{ field.label }}</label>
        </span>
        <!--
          A unidade fica à esquerda, fora do número, e o valor à direita (N4): como prefixo do campo, "R$ mil 18,7"
          saía colado.
        -->
        <span class="income__input" [class.income__input--adjusted]="isAdjusted(field.key)">
          <span class="income__unit" aria-hidden="true">R$ mil</span>
          <app-input
            class="income__control"
            [id]="'pit-income-' + field.key"
            [type]="'number'"
            [minFractionDigits]="0"
            [maxFractionDigits]="1"
            [textCenter]="false"
            [disabled]="!canEdit() || busy()"
            [placeholder]="field.key === 'livingCost' ? 'Não informado' : ''"
            [ngModel]="thousands(field.key)"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onValue(field.key, $event)" />
        </span>
        <!-- Origem como legenda embaixo do campo: o rótulo fica com a linha inteira (N4). -->
        <span class="income__origin" [class.income__adjusted]="isAdjusted(field.key)">
          {{ isAdjusted(field.key) ? 'Ajustado' : field.originLabel }}
        </span>
      </div>
    }
  </div>

  <div class="income__summary">
    <div>
      <span>= Recursos disponíveis no ano</span>
      <b class="pit-num">{{ money(resources()) }}</b>
    </div>
    <div>
      <span>− Acréscimo patrimonial (da declaração)</span>
      <b class="pit-num">{{ money(test().netWorthIncrease, true) }}</b>
    </div>
    <div>
      <span class="pit-strong">= Renda que sobra após o crescimento patrimonial</span>
      <b class="pit-num" [class.pit-positive]="compatible()" [class.pit-negative]="!compatible()">
        {{ money(result(), true) }}
      </b>
    </div>
  </div>

  @if (anyAdjusted()) {
    <div class="pit-callout">
      <span>
        Valores ajustados manualmente. O resultado e os indicadores já refletem o ajuste.
        @if (test().adjustedBy) {
          Último ajuste por {{ test().adjustedBy }}.
        }
      </span>
      @if (canEdit()) {
        <app-button
          [label]="'Restaurar valores da declaração'"
          [outlined]="true"
          [size]="'small'"
          [fitContent]="true"
          [disabled]="busy()"
          (sendButtonClick)="restore.emit(test().returnId)" />
      }
    </div>
  }
</section>
